import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mend = defineConnector({
  identifier: "mend",
  name: "Mend.io",
  tagLine: "Application security and SCA",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api-saas\\.mend\\.io/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a JWT access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://api-docs.mend.io/platform/3.0/access-management/login](https://api-docs.mend.io/platform/3.0/access-management/login) to sign in with your Mend credentials and obtain the JWT access token used by the Mend API.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "JWT access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://api-saas.mend.io/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url: testUrl ?? (() => "https://api-saas.mend.io/")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
